import { Model } from '../parents/model';

export class CustomerModel extends Model {
  static ATTR_ID = 'id';

  static ATTR_FIRST_NAME = 'first_name';

  static ATTR_LAST_NAME = 'last_name';

  static ATTR_DIAL_CODE = 'dial_code';

  static ATTR_PHONE = 'phone';

  static ATTR_EMAIL = 'email';

  get id() {
    return this.attributes[CustomerModel.ATTR_ID];
  }

  get firstName() {
    return this.attributes[CustomerModel.ATTR_FIRST_NAME];
  }

  get lastName() {
    return this.attributes[CustomerModel.ATTR_LAST_NAME];
  }

  get dialCode() {
    return this.attributes[CustomerModel.ATTR_DIAL_CODE];
  }

  get phone() {
    return this.attributes[CustomerModel.ATTR_PHONE];
  }

  get email() {
    return this.attributes[CustomerModel.ATTR_EMAIL];
  }
}
